import { Component, Input, OnInit } from "@angular/core";
import { Development, legendColorCollection } from "@models/development.model";
import { CapitalNeedsService } from "@services/capital-needs.service";
import { CommonServiceService } from "@services/common-service.service";
import { DevelopmentService } from "@services/development.service";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  barChartAverageDevelopment,
  barChartTitle,
  chartFontFamily,
  currencyFormatter,
} from "src/app/constants/charts-const";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: ["./bar-chart.component.scss"],
})
export class BarChartComponent implements OnInit {
  @Input() development!: Development;
  barChart: any;

  chartLegends: legendColorCollection[] = [];
  constructor(
    private capitalNeedsService: CapitalNeedsService,
    private commonServiceService: CommonServiceService,
    private developmentService: DevelopmentService,
  ) {}

  ngOnInit(): void {
    this.createChart();
    this.getChartLables();
  }

  createChart() {
    this.barChart = new Chart("barChart", {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: this.commonServiceService.removeStringAfterParenthesesAndTitleCase(
              this.development?.name,
            ),
            data: [Math.round(this.getTwentyYearProjectBudget())],
            backgroundColor: ["rgba(99, 166, 157, 1)"],
            datalabels: {
              color: this.getChartLabelColor(
                this.getTwentyYearProjectBudget(),
                this.getAverageTwentyYearPerApartment(),
              ),
              // color: "#FFFFFF",
              // padding: { bottom: 50 },
              textAlign: "end",
              font: {
                weight: "bolder",
                size: 14,
              },
            },
            hoverOffset: 4,
          },
          {
            label: barChartAverageDevelopment,
            data: [this.getAverageTwentyYearPerApartment()],
            backgroundColor: ["rgba(25, 67, 32, 1)"],
            datalabels: {
              color: this.getChartLabelColor(
                this.getAverageTwentyYearPerApartment(),
                this.getTwentyYearProjectBudget(),
              ),
              // padding: { bottom: 50 },
              textAlign: "end",
              font: {
                weight: "bolder",
                size: 14,
              },
            },
            hoverOffset: 4,
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        plugins: {
          title: barChartTitle,
          legend: {
            position: "bottom",
            display: false,
            labels: {
              color: "#000000",
              boxWidth: 12,
              font: {
                size: 12,
                weight: "bolder",
                family: chartFontFamily,
              },
            },
          },
          datalabels: {
            display: true,
            formatter: (value, context) => {
              return currencyFormatter.format(value);
            },
            font: {
              size: 12,
              weight: "bolder",
              family: chartFontFamily,
            },
          },
        },

        scales: {
          y: {
            display: false,
            grid: {
              display: false,
            },
          },
          x: {
            display: false,
            grid: {
              display: true,
            },
          },
        },
        aspectRatio: window.innerWidth <= 1280 ? 1.5 : 1.6,
      },
    });
  }

  getTwentyYearProjectBudget(): number {
    const noOfUnits = parseInt(this.development.noOfUnits.toString().replaceAll(",", ""));
    return noOfUnits > 0
      ? this.development.areasOfWork
          .flatMap((x) => x.twentyYearCapitalNeeds)
          .reduce((acc, cur) => acc + Number(cur), 0) / noOfUnits
      : 0;
  }

  getChartLabelColor(comparer: number, comparision: number): string {
    return (comparer / comparision) * 100 > 5 ? "#FFFFFF" : "#000000";
  }

  getAverageTwentyYearPerApartment(): number {
    return environment.Average20YearCapitalNeeds;
    // const TotalUnits = this.developmentService
    //   .getItems()
    //   .flatMap((x) => x.noOfUnits)
    //   .reduce((acc, cur) => acc + Number(cur), 0);
    // console.log(TotalUnits, Math.round(this.capitalNeedsService.getTwentyYearCapitalNeeds()));
    // return Math.round(this.capitalNeedsService.getTwentyYearCapitalNeeds()) / TotalUnits;
  }

  getChartLables() {
    this.chartLegends.push({
      legendName: this.commonServiceService.removeStringAfterParenthesesAndTitleCase(
        this.development?.name,
      ),
      colorCoding: "rgba(99, 166, 157, 1)",
    });
    this.chartLegends.push({
      legendName: barChartAverageDevelopment,
      colorCoding: "rgba(25, 67, 32, 1)",
    });
  }
}
